/* eslint-disable no-undef */
import { NativeModules, InteractionManager } from 'react-native';

const hasPurchaseString = (str = '') => {
  return str.includes('purchase');
};

const _trackState = (pageName, params, isLoadEvent) => {
  // console.log('_trackState: ', pageName, params)
  if (typeof s === 'undefined') {
    return;
  }
  // eslint-disable-next-line no-unused-vars
  s.linkTrackVars = 'channel,eVar1,eVar15,eVar24,eVar34,prop24,eVar75';
  const keys = Object.keys(params);
  keys.forEach((key) => {
    const newKey = key.replace('m_c', 'prop').replace('m_v', 'eVar').replace('m_', '');
    s.linkTrackVars += `,${newKey}`;
    s[newKey] = params[key];
  });
  s.eVar1 = 'PWA_RNW';
  s.eVar15 = pageName;
  s.pageName = pageName;
  s.eVar18 = s.getVisitNum();
  s.eVar75 = 'PWA_RNW_Direct';
  const isThankYouPage = pageName?.includes('Thank_You');

  if (isThankYouPage && !hasPurchaseString(s.events)) {
    if (s.events) {
      s.events = s.events + ',purchase';
    } else {
      s.events = 'purchase';
    }
  }

  if (isLoadEvent) {
    const sCode = s.t(this, 'o', pageName);
    if (sCode) {
      document.write(sCode);
    }
    trackNativeAppInstalled(pageName)
  } else {
    const sCode = s.tl(this, 'o', pageName);
    if (sCode) {
      document.write(sCode);
    }
  }
};

const _trackStateSafe = (...args) => {
  try {
    InteractionManager.runAfterInteractions(() => {
      _trackState(...args);
    })
  } catch (e) {
    // ignore
    console.log('err', e)
  }
};

function trackNativeAppInstalled(pageName) {
  if (!navigator || !navigator.getInstalledRelatedApps) {
    return
  }
  if (!sessionStorage) {
    return;
  }
  const KEY = "logTrackNativeAppInstalled";
  const alreadyLogged = sessionStorage.getItem(KEY)
  if (alreadyLogged) {
    return;
  }
  sessionStorage.setItem(KEY, true)
  navigator.getInstalledRelatedApps()
    .then(function (apps) {
      const hasApp = apps.length > 0
      _trackState(pageName, {
        prop61: `app_installed_${hasApp}`
      })
    })

}


NativeModules.OmnitureModule = {
  trackState: _trackStateSafe
};
